import { isFunction } from "@tradingApp/utils/isFunction";

export function gaExists(w: Window): w is Window & { gtag: Gtag.Gtag } {
  return w !== undefined && "gtag" in w && isFunction(w.gtag);
}
